// @ts-nocheck
const ActionTypes = {
  ROUTER_STATE_CHANGE: 'ROUTER_STATE_CHANGE',

  SIGNUP: 'SIGNUP',
  SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
  SIGNUP_FAILURE: 'SIGNUP_FAILURE',

  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT: 'LOGOUT',
  LOGOUT_PROFILE_SUCCESS: 'LOGOUT_PROFILE_SUCCESS',

  FETCH_PROFILE: 'FETCH_PROFILE',
  FETCH_PROFILE_SUCCESS: 'FETCH_PROFILE_SUCCESS',
  FETCH_PROFILE_FAILURE: 'FETCH_PROFILE_FAILURE',

  SAVE_PROFILE: 'SAVE_PROFILE',
  SAVE_PROFILE_SUCCESS: 'SAVE_PROFILE_SUCCESS',
  SAVE_PROFILE_FAILURE: 'SAVE_PROFILE_FAILURE',

  FETCH_POST: 'FETCH_POST',
  FETCH_POST_SUCCESS: 'FETCH_POST_SUCCESS',
  FETCH_POST_FAILURE: 'FETCH_POST_FAILURE',

  FETCH_LAYOUTS_SUCCESS: 'FETCH_LAYOUTS_SUCCESS',
  FETCH_LAYOUTS_FAILURE: 'FETCH_LAYOUTS_FAILURE',
  UPDATE_LAYOUT: 'UPDATE_LAYOUT',
  UPDATE_LAYOUT_FAILURE: 'UPDATE_LAYOUT_FAILURE',
  ADD_LAYOUT: 'ADD_LAYOUT',
  ADD_LAYOUT_FAILURE: 'ADD_LAYOUT_FAILURE',
  DELETE_LAYOUT: 'DELETE_LAYOUT',

  SAVE_POST: 'SAVE_POST',
  SAVE_POST_SUCCESS: 'SAVE_POST_SUCCESS',
  SAVE_POST_FAILURE: 'SAVE_POST_FAILURE',

  SET_ALL_UPLOADS: 'SET_ALL_UPLOADS',
  SET_REGISTRATION_FORMS: 'SET_REGISTRATION_FORMS',
  ADD_REGISTRATION_FORMS: 'ADD_REGISTRATION_FORMS',
  UPDATE_REGISTRATION_FORMS: 'UPDATE_REGISTRATION_FORMS',

  SET_TEAM_REGISTRATIONS: 'SET_TEAM_REGISTRATIONS',
  SET_TEAM_REGISTRATION: 'SET_TEAM_REGISTRATION',
  ADD_TEAM_REGISTRATIONS: 'ADD_TEAM_REGISTRATIONS',
  SAVE_TEAM_REGISTRATION_SUCCESS: 'SAVE_TEAM_REGISTRATION_SUCCESS',
  UPDATE_TEAM_REGISTRATIONS: 'UPDATE_TEAM_REGISTRATIONS',

  SET_ORGANIZATION: 'SET_ORGANIZATION',
  SET_ORGANIZATION_BANNER: 'SET_ORGANIZATION_BANNER',
  SET_ALL_ORGANIZATIONS: 'SET_ALL_ORGANIZATIONS',
  POST_ORGANIZATION_BANNER: 'POST_ORGANIZATION_BANNER',
  DELETE_ORGANIZATION: 'DELETE_ORGANIZATION',

  SET_LEAGUE: 'SET_LEAGUE',
  SET_LEAGUES_BY_ORGANIZATION: 'SET_LEAGUES_BY_ORGANIZATION',
  SET_ALL_LEAGUES: 'SET_ALL_LEAGUES',
  UPDATE_LEAGUE: 'UPDATE_LEAGUE',
  ADD_LEAGUE: 'ADD_LEAGUE',
  DELETE_LEAGUE: 'DELETE_LEAGUE',

  SET_DIVISION: 'SET_DIVISION',
  SET_ALL_ACTIVE_DIVISIONS: 'SET_ALL_ACTIVE_DIVISIONS',
  SET_DIVISIONS_BY_LEAGUE: 'SET_DIVISIONS_BY_LEAGUE',
  SET_DIVISIONS_BY_PREV_LEAGUE: 'SET_DIVISIONS_BY_PREV_LEAGUE',
  UPDATE_DIVISION: 'UPDATE_DIVISION',
  ADD_DIVISION: 'ADD_DIVISION',
  DELETE_DIVISION: 'DELETE_DIVISION',

  SET_TEAM: 'SET_TEAM',
  SET_TEAMS_BY_LEAGUE: 'SET_TEAMS_BY_LEAGUE',
  SET_TEAMS_BY_DIVISION: 'SET_TEAMS_BY_DIVISION',
  UPDATE_TEAM: 'UPDATE_TEAM',
  ADD_TEAM: 'ADD_TEAM',
  DELETE_TEAM: 'DELETE_TEAM',

  SEARCH_TEAM_BY_NAME: 'SEARCH_TEAM_BY_NAME',

  UPDATE_TEAM_DIVISION: 'UPDATE_TEAM_DIVISION',
  ADD_TEAM_DIVISION: 'ADD_TEAM_DIVISION',
  SET_TEAM_DIVISION_BY_DIVISION: 'SET_TEAM_DIVISION_BY_DIVISION',
  DELETE_TEAM_DIVISION: 'DELETE_TEAM_DIVISION',

  SET_GAME: 'SET_GAME',
  SET_GAMES_WITH_FILTERS: 'SET_GAMES_WITH_FILTERS',
  SET_GAMES_BY_TEAM: 'SET_GAMES_BY_TEAM',
  SET_ALL_GAMES: 'SET_ALL_GAMES',
  SET_GAMES_BY_DIVISION: 'SET_GAMES_BY_DIVISION',
  UPDATE_GAME: 'UPDATE_GAME',
  ADD_GAME: 'ADD_GAME',
  DELETE_GAME: 'DELETE_GAME',

  SET_PLAYERS_WITH_FILTERS: 'SET_PLAYERS_WITH_FILTERS',
  SEARCH_PLAYER: 'SEARCH_PLAYER',
  SET_PLAYER: 'SET_PLAYER',
  SET_PLAYERS_BY_TEAM: 'SET_PLAYERS_BY_TEAM',
  SET_PLAYERS_BY_GAME: 'SET_PLAYERS_BY_GAME',
  UPDATE_PLAYER: 'UPDATE_PLAYER',
  ADD_PLAYER: 'ADD_PLAYER',
  DELETE_PLAYER: 'DELETE_PLAYER',

  SET_STATS_OF_PLAYER: 'SET_STATS_OF_PLAYER',
  SET_STATS_OF_PLAYER_LIST: 'SET_STATS_OF_PLAYER_LIST',
  SET_STATS_OF_TEAM: 'SET_STATS_OF_TEAM',
  SET_STATS_OF_GAME: 'SET_STATS_OF_GAME',
  UPDATE_STAT: 'UPDATE_STAT',
  ADD_STAT: 'ADD_STAT',
  SET_COMBINED_STATS_OF_TEAM_BY_DIVISION: 'SET_COMBINED_STATS_OF_TEAM_BY_DIVISION',

  SET_PLAYER_TO_WATCH_LIST: 'SET_PLAYER_TO_WATCH_LIST',
  REMOVE_PLAYER_FROM_WATCH_LIST: 'REMOVE_PLAYER_FROM_WATCH_LIST',

  SET_USER: 'SET_USER',
  REMOVE_USER: 'REMOVE_USER',

  SHOW_LOGIN_MODAL: 'SHOW_LOGIN_MODAL',
  HIDE_LOGIN_MODAL: 'HIDE_LOGIN_MODAL',

  SHOW_SUCCESS: 'SHOW_SUCCESS',
  SHOW_ERROR: 'SHOW_ERROR',
} as const;

export type ActionType = typeof ActionTypes[keyof typeof ActionTypes];

export default ActionTypes;
